import { Outlet, useLocation } from "react-router";
import { Suspense, useRef } from "react";
import PageLoader from "../component/PageLoader";
import Navbar from "../component/Navbar";
import { useEffect } from "react";
import Contactus from '../component/Contactus'
import Footer from "../component/Footer";
import PageCard from "../component/PageCard";
import JobApply from "../component/JobApply";
import useSocialMeta from "./useSocialMeta";
import useCinematicScroll from "../hooks/useCinematicScroll";

const Layout = () => {
  const { pathname,hash } = useLocation();

  const contentRef = useRef(null);
  useCinematicScroll(contentRef, pathname);
  useSocialMeta();

  useEffect(() => {
    const sectionKey = hash.slice(1);
    if (sectionKey=== "") {
    window.scrollTo({ top: 0, behavior: "auto" }); // or "smooth" if you prefer
    }
  }, [pathname]);
 
  return (
    <div>
      <a className="skip-link" href="#main">Skip to content</a>
      <Navbar />
      <div ref={contentRef} id="main" tabIndex={-1}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </div>
      <PageCard />
      <Footer />
      <Contactus />
      <JobApply/>
    </div>
  );
};

export default Layout;
